export default __webpack_public_path__ + "static/media/step_A_EN.461875c2.png";